import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { DndProvider, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './TestPattern.css';
import QuestionCard from './QuestionCard';
import DraggableQuestionCard from './DraggableQuestionCard';

// Компонент корзины с поддержкой drop
const DropBasket = ({ children, onDrop }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: 'question',
    drop: (item) => onDrop(item.question),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  return (
    <div 
      ref={drop} 
      className={`TestBasket ${isOver ? 'drag-over' : ''}`}
    >
      {children}
    </div>
  );
};

const EditTestPattern = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [testName, setTestName] = useState('');
  const [testDescription, setTestDescription] = useState('');
  const [questions, setQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [activeTypes, setActiveTypes] = useState({
    sociometry: false,
    leadership: false,
    belben: false
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Загрузка данных теста и всех вопросов
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const token = localStorage.getItem('authToken');
        if (!token) {
          throw new Error('Токен авторизации не найден');
        }

        // Загрузка данных теста
        const testResponse = await fetch(`http://185.250.149.189:8000/api/v1/TestPatterns?id=${id}`, {
          headers: { 
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (!testResponse.ok) {
          throw new Error('Ошибка загрузки теста');
        }
        
        const testData = await testResponse.json();
        const pattern = testData.pattern;
        
        setTestName(pattern.name);
        setTestDescription(pattern.description);
        
        // Загрузка всех вопросов
        const questionsResponse = await fetch('http://185.250.149.189:8000/api/v1/Question', {
          headers: { 
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (!questionsResponse.ok) {
          throw new Error('Ошибка загрузки вопросов');
        }
        
        const questionsData = await questionsResponse.json();
        
        // Фильтрация вопросов по нужным типам
        const validQuestions = questionsData.quests.filter(q => 
          ['sociometry', 'leadership', 'belben'].includes(q.quest_type)
        );
        
        setQuestions(validQuestions);
        
        // Сопоставление вопросов из теста с полными данными
        const fullSelectedQuestions = pattern.questions.map(selectedQ => {
          const fullQuestion = validQuestions.find(q => q.id === selectedQ.id);
          return fullQuestion ? fullQuestion : selectedQ;
        });
        
        setSelectedQuestions(fullSelectedQuestions);
        setInitialDataLoaded(true);
        
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
        setError(`Ошибка: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // Обновляем активные типы при изменении выбранных вопросов
  useEffect(() => {
    if (!initialDataLoaded) return;
    
    const newActiveTypes = {
      sociometry: selectedQuestions.some(q => q.quest_type === 'sociometry'),
      leadership: selectedQuestions.some(q => q.quest_type === 'leadership'),
      belben: selectedQuestions.some(q => q.quest_type === 'belben')
    };
    setActiveTypes(newActiveTypes);
  }, [selectedQuestions, initialDataLoaded]);

  // Обработчик для выбора/отмены всех вопросов типа
  const handleGroupSelect = (type) => {
    const typeQuestions = questions.filter(q => q.quest_type === type);
    const isTypeActive = activeTypes[type];
    
    if (isTypeActive) {
      // Удаляем все вопросы этого типа
      setSelectedQuestions(prev => prev.filter(q => q.quest_type !== type));
    } else {
      // Добавляем все вопросы этого типа
      const newQuestions = typeQuestions.filter(q => 
        !selectedQuestions.some(sq => sq.id === q.id)
      );
      setSelectedQuestions(prev => [...prev, ...newQuestions]);
    }
  };

  // Обработчик выбора вопроса
  const handleQuestionSelect = (question) => {
    if (!selectedQuestions.some(q => q.id === question.id)) {
      setSelectedQuestions(prev => [...prev, question]);
    }
  };

  // Обработчик удаления вопроса
  const handleQuestionDeselect = (questionId) => {
    setSelectedQuestions(prev => prev.filter(q => q.id !== questionId));
  };

  // Обработчик drop в корзину
  const handleDropToBasket = (question) => {
    if (!selectedQuestions.some(q => q.id === question.id)) {
      setSelectedQuestions(prev => [...prev, question]);
    }
  };

  // Обработчик сохранения с обновлением данных
  const handleSave = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('Токен авторизации не найден');
      }

      // Формируем данные для отправки в новом формате
      const updateData = {
          id: parseInt(id), // ID шаблона, который меняем
          name: testName,
          description: testDescription,
          is_param: true,
          param_count: 0,
          questions: selectedQuestions.map(q => ({
            id: q.id,
            title: q.title,
            quest_type: q.quest_type,
            data: q.data
          }))
      };

      console.log('Данные для обновления:', JSON.stringify(updateData, null, 2));
      
      // Отправка POST запроса на обновление
      const response = await fetch('http://185.250.149.189:8000/api/v1/TestPatternUpdate', {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
      });

      const responseData = await response.json();
      
      if (!response.ok) {
        console.error('Ошибка при обновлении теста:', responseData);
        throw new Error(responseData.message || 'Ошибка при обновлении теста');
      }

      console.log('Тест успешно обновлен:', responseData);
      alert('Тест успешно обновлен!');
      navigate('/tests');
    } catch (error) {
      console.error('Ошибка при сохранении теста:', error);
      setError(`Ошибка: ${error.message}`);
    }
  };

  // Группировка вопросов по типам
  const getQuestionsByType = (type) => {
    return questions.filter(q => q.quest_type === type);
  };

  // Функция для получения русского названия типа
  const getTypeName = (type) => {
    switch(type) {
      case 'sociometry': return 'Социометрия';
      case 'leadership': return 'Лидерство';
      case 'belben': return 'Роль в команде';
      default: return type;
    }
  };

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px'
      }}>
        Загрузка данных теста...
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-message" style={{ margin: '20px', padding: '15px' }}>
        {error}
      </div>
    );
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="TestPattern"> 
        <div className="TestPatternHead"> 
          <h1>Редактирование теста</h1>
          <button className="SaveButton" onClick={handleSave}>Сохранить</button>
        </div>
        
        <div className="TestPatternDescription"> 
          <div className="TestName">
            Название теста 
            <textarea 
              className='input1' 
              name="test_name" 
              placeholder="Введите название теста"
              value={testName}
              onChange={(e) => setTestName(e.target.value)}
            ></textarea>
          </div>
          <div className="TestDes">
            Описание теста
            <textarea 
              className='input2' 
              name="test_Des" 
              placeholder="Опишите тест"
              value={testDescription}
              onChange={(e) => setTestDescription(e.target.value)}
            ></textarea>
          </div>
        </div>
        
        <div className="TestQuest"> 
          <div className="TestType"> 
            <h2>Возможные вопросы</h2>
            <div className="TestTypeInAll">
              <div 
                className={`TestTypeIn1 ${activeTypes.sociometry ? 'active' : ''}`}
                onClick={() => setActiveTypes(prev => ({...prev, sociometry: !prev.sociometry}))}
              >
                Социометрия параметр.
              </div>
              <div 
                className={`TestTypeIn2 ${activeTypes.sociometry ? 'active' : ''}`}
                onClick={() => setActiveTypes(prev => ({...prev, sociometry: !prev.sociometry}))}
              >
                Социометрия непараметр.
              </div>
              <div 
                className={`TestTypeIn3 ${activeTypes.leadership ? 'active' : ''}`}
                onClick={() => setActiveTypes(prev => ({...prev, leadership: !prev.leadership}))}
              >
                Лидерство
              </div>
              <div 
                className={`TestTypeIn4 ${activeTypes.belben ? 'active' : ''}`}
                onClick={() => setActiveTypes(prev => ({...prev, belben: !prev.belben}))}
              >
                Роль в команде
              </div>
            </div>
          </div>
          <div className="TestNumber"> 
            <h2>{selectedQuestions.length} вопросов в вашем тесте</h2>
            <p>Добавьте в ваш тест вопросы из левого окна, перетащив их вправо или нажав на «+».
                Чтобы убрать вопросы из теста, перетащите их влево или нажмите на «-».</p>
          </div>
        </div>
        
        <div className="TestSelection"> 
          <div className="TestShowcase"> 
            {/* Группа социометрии */}
            <div className="question-group">
              <div className="group-header">
                <h3>Социометрия:</h3>
                <button 
                  className={`group-btn ${activeTypes.sociometry ? 'remove' : 'add'}`}
                  onClick={() => handleGroupSelect('sociometry')}
                >
                  {activeTypes.sociometry ? 'Удалить все' : 'Добавить все'}
                </button>
              </div>
              <div className="questions-container">
                {getQuestionsByType('sociometry').map(question => (
                  <DraggableQuestionCard 
                    key={question.id} 
                    question={question} 
                    isSelected={selectedQuestions.some(q => q.id === question.id)}
                    onSelect={handleQuestionSelect}
                    onDeselect={handleQuestionDeselect}
                  />
                ))}
              </div>
            </div>
            
            {/* Группа лидерства - изменена: убраны индивидуальные карточки */}
            <div className="question-group">
              <div className="group-header">
                <h3>Лидерство:</h3>
                <button 
                  className={`group-btn ${activeTypes.leadership ? 'remove' : 'add'}`}
                  onClick={() => handleGroupSelect('leadership')}
                >
                  {activeTypes.leadership ? 'Удалить все' : 'Добавить все'}
                </button>
              </div>
              <div className="questions-container">
                {getQuestionsByType('leadership').map(question => (
                  <div key={question.id} className="question-card static">
                    <div className="question-content">
                      <h4>{question.title}</h4>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Группа роли в команде - изменена: убраны индивидуальные карточки */}
            <div className="question-group">
              <div className="group-header">
                <h3>Роль в команде:</h3>
                <button 
                  className={`group-btn ${activeTypes.belben ? 'remove' : 'add'}`}
                  onClick={() => handleGroupSelect('belben')}
                >
                  {activeTypes.belben ? 'Удалить все' : 'Добавить все'}
                </button>
              </div>
              <div className="questions-container">
                {getQuestionsByType('belben').map(question => (
                  <div key={question.id} className="question-card static">
                    <div className="question-content">
                      <h4>{question.title}</h4>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <DropBasket onDrop={handleDropToBasket}> 
            <h3>Выбранные вопросы</h3>
            <div className="selected-questions">
              {selectedQuestions.map(question => {
                // Для вопросов лидерства и роли в команде показываем статические карточки без возможности удаления
                if (question.quest_type === 'leadership' || question.quest_type === 'belben') {
                  return (
                    <div key={question.id} className="question-card static">
                      <div className="question-content">
                        <h4>{question.title}</h4>
                      </div>
                    </div>
                  );
                } else {
                  // Для социометрии оставляем обычные карточки с возможностью удаления
                  return (
                    <QuestionCard 
                      key={question.id} 
                      question={question} 
                      onDeselect={handleQuestionDeselect}
                      isSelected={true}
                    />
                  );
                }
              })}
            </div>
          </DropBasket>    
        </div>
      </div>
    </DndProvider>
  )
}

export default EditTestPattern;